import { render, staticRenderFns } from "./JobBoard.vue?vue&type=template&id=648a8e95&scoped=true&"
import script from "./JobBoard.vue?vue&type=script&lang=js&"
export * from "./JobBoard.vue?vue&type=script&lang=js&"
import style0 from "./JobBoard.vue?vue&type=style&index=0&id=648a8e95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648a8e95",
  null
  
)

export default component.exports